/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="81.46"
        height="81.31"
        viewBox="0 0 81.46 81.31"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M32.93 11.94v4.17l-.65.12-.66.14a10 10 0 0 0-7.55 6.12 12.42 12.42 0 0 0-.87 5.72 9.8 9.8 0 0 0 5.3 8.34 39.42 39.42 0 0 0 4.39 2c1.84.78 3.7 1.48 5.54 2.26a3.36 3.36 0 0 1 2.07 3.63 3.66 3.66 0 0 1-3 3.66 10.79 10.79 0 0 1-2.33.25 5.75 5.75 0 0 1-5.89-4.31c-.17-.51-.3-1-.46-1.6l-7 1.8a14.42 14.42 0 0 0 3.39 6.94 11.78 11.78 0 0 0 7.68 3.54v5.39h4.61v-5.37c.91-.18 1.8-.32 2.66-.54a10.46 10.46 0 0 0 7.38-6 12.23 12.23 0 0 0 .85-7.31 9.63 9.63 0 0 0-4.91-6.95A54.78 54.78 0 0 0 36.77 31c-1.37-.54-2.71-1.18-4-1.82a2.89 2.89 0 0 1-1.58-1.85 4.07 4.07 0 0 1 2.69-5.1l.17-.05a4.76 4.76 0 0 1 4.69 1.22 9 9 0 0 1 1.91 2.93c.15.34.29.69.45 1.06l6.28-2.59a12.73 12.73 0 0 0-2.31-4.73 11 11 0 0 0-7.62-4V11.9Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M.1 32.65a35.39 35.39 0 1 1 67.4 17.61 1.253 1.253 0 1 1-2.27-1.06 32.87 32.87 0 1 0-17.78 16.68 1.253 1.253 0 0 1 .92 2.33A35.41 35.41 0 0 1 .1 32.65Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M50.28 49.11h.46l29.89 10.63a1.25 1.25 0 0 1 .77 1.59 1.23 1.23 0 0 1-.57.68l-.13.06-9.08 3.85 7.69 8.75a1.28 1.28 0 0 1 0 1.61l-.1.1-4.57 4.58a1.25 1.25 0 0 1-1.74 0l-.1-.1-8-9.3-4.73 8.84a1.24 1.24 0 0 1-1.69.51 1.21 1.21 0 0 1-.57-.63v-.12l-8.66-29.49v-.8l.05-.11.1-.15.07-.09.09-.09.09-.07.11-.06.11-.06h.28Zm2 3.25 7.12 24.25 4.15-7.75a1.25 1.25 0 0 1 1.68-.56 1.44 1.44 0 0 1 .32.23l.09.1 8.29 9.67 2.8-2.8-8.13-9.13a1.25 1.25 0 0 1 .11-1.75 1.88 1.88 0 0 1 .23-.16l.11-.06 7.73-3.28Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignWithCircleAndMouseArrowIcon';

export default Icon;
